import React from 'react';
import ConversationContextType from '../types/ConversationContextType';

const ConversationContext = React.createContext<ConversationContextType>({ conversationId: '' });

export default ConversationContext;